import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";

import { useGetBranchesQuery } from "../../../redux/Service/branches";
// import { useGetVendorsQuery } from "../../../redux/Service/vendorsApi";
import { useGetBoxsQuery } from "../../../redux/Service/BoxesApi";
import { useGetBanksQuery } from "../../../redux/Service/BanksApi";
import {
  useAddSalesBillMutation,
  useDeleteSalesBillMutation,
  useEditSalesBillMutation,
  useGetSalesBillQuery,
  useLazyGetSalesBillByDocQuery,
} from "../../../redux/Service/SalesBillApi";
import { useGetCustomersQuery } from "../../../redux/Service/customersApi";

function SalesBill() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [subData, setSubData] = useState<any>([]);
  const [cashSubData, setCashSubData] = useState<any>([]);

  const { data: billData, isLoading } = useGetSalesBillQuery(undefined);
  const bills = billData?.ResponseObject ?? [];

  const { data: branchesData } = useGetBranchesQuery(undefined);
  const branches = branchesData?.ResponseObject ?? [];

  // const { data: vendorsData } = useGetVendorsQuery(undefined);
  // const vendors = vendorsData?.ResponseObject ?? [];

  const { data: customersData } = useGetCustomersQuery(undefined);
  const customers = customersData?.ResponseObject ?? [];

  const { data: boxesData } = useGetBoxsQuery(undefined);
  const boxes = boxesData?.ResponseObject ?? [];

  const { data: banksData } = useGetBanksQuery(undefined);
  const banks = banksData?.ResponseObject ?? [];

  const [triggerGetBill] = useLazyGetSalesBillByDocQuery();
  const [addBill] = useAddSalesBillMutation();
  const [editBill] = useEditSalesBillMutation();
  const [deleteBill] = useDeleteSalesBillMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الفاتورة "${record.DocID}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const res = await deleteBill(record.DocID).unwrap();
          if (res?.ResponseObject === true) {
            message.success("تم حذف الفاتورة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleEditClick = async (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);

    try {
      const res = await triggerGetBill(record.DocID).unwrap();
      const rawData = res?.ResponseObject[0];

      if (rawData) {
        const recordData = { ...rawData };
        recordData.DocDate = dayjs(recordData.DocDate);
        recordData.DueDate = dayjs(recordData.DueDate);
        setSubData(recordData.SalesItems || []);
        setCashSubData(recordData.SalesCashes || []);

        setTimeout(() => {
          form.setFieldsValue(recordData);
        }, 0);
      }
    } catch {
      message.error("فشل في جلب بيانات الفاتورة");
    }
  };

  const handleOk = async (values) => {
    const body = {
      ...values,
      DocDate: values.DocDate?.format("YYYY-MM-DD"),
      DueDate: values.DueDate?.format("YYYY-MM-DD"),
      SalesItems: subData,
      SalesCashes: cashSubData,
    };

    try {
      let res;
      if (isEditing) {
        res = await editBill(body).unwrap();
      } else {
        res = await addBill(body).unwrap();
      }

      if (res?.ResponseObject === true) {
        message.success(isEditing ? "تم تعديل الفاتورة" : "تمت إضافة الفاتورة");
        resetModal();
        setIsModalOpen(false);
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const resetModal = () => {
    form.resetFields();
    setSubData([]);
    setCashSubData([]);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const columns = [
    { title: "رقم المستند", dataIndex: "DocID", key: "DocID" },
    {
      title: "اسم العميل",
      dataIndex: "CustomerName",
      key: "CustomerName",
      // render: (_: any, record: any) =>
      //   vendors.find((v) => v.VendorID === record.VendorId)?.VendorName,
    },
    {
      title: "الفرع",
      dataIndex: "BranchId",
      key: "BranchId",
      render: (_: any, record: any) =>
        branches.find((b) => b.BranchID === record.BranchId)?.BranchName,
    },
    {
      title: "التاريخ",
      dataIndex: "DocDate",
      key: "DocDate",
    },
    {
      title: "الإجمالي",
      dataIndex: "NetTotal",
      key: "NetTotal",
    },
  ];

  return (
    <>
      <Heading name={"فواتير المبيعات"} />
      <div className="flex flex-wrap gap-4">
        <div className="grid justify-start">
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            إضافة فاتورة
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          initialValues={{
            DocDate: dayjs(),
            DueDate: dayjs(),
            CurrRate: 1,
          }}
          loading={false}
          subData={subData}
          cashSubData={cashSubData}
          setSubData={setSubData}
          setCashSubData={setCashSubData}
          // vendors={vendors}
          customers={customers}
          branches={branches}
          boxes={boxes}
          banks={banks}
        />

        <DataTable
          columns={columns}
          data={bills}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}

export default SalesBill;
